// extracted by mini-css-extract-plugin
export default {"mainContainer":"Nav_mainContainer__nOLgf","navLink":"Nav_navLink__GwS3d"};